<template>
  <el-tabs v-model="activeName" class="personal">
    <el-tab-pane :label="this.$t('menu.basic')" name="info" class="section">
      <!-- <div class="boxheader">{{$t('basic.basic')}}</div> -->
      <el-form :model="infoForm" :rules="infoFormRules" ref="infoForm" class="chuangjian grid">
        <el-form-item prop="photo" label=" ">
          <upload :picSmall.sync="infoForm.photo"></upload>
        </el-form-item>
        <el-form-item prop="usr" :label="this.$t('basic.User_name')">
          <el-input v-model="infoForm.usr" disabled>
            <!-- <img slot="prefix" src="@/assets/img/usr_gl.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item prop="qname" :label="this.$t('basic.Nickname')">
          <el-input v-model="infoForm.qname">
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item prop="email" :label="this.$t('basic.Email')">
          <el-input v-model="infoForm.email">
            <!-- <img slot="prefix" src="@/assets/img/youxiang.png" style="width:19px;height:14px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item prop="mobile" :label="this.$t('basic.Mobile')">
          <el-input v-model="infoForm.mobile">
            <!-- <img slot="prefix" src="@/assets/img/shouji.png" style="width:13px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item label=" ">
          <div class="buttonSave">
            <el-button class="button button-solid" @click="submitForm">{{$t('basic.Save')}}</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 修改密码 -->
    <el-tab-pane :label="this.$t('menu.password')" name="pwd" class="section">
      <el-form
        style="margin-top:150px"
        :model="passwordForm"
        :rules="passwordFormRules"
        ref="passwordForm"
        class="chuangjian grid"
      >
        <el-form-item :label="this.$t('password.User_name')" prop="usr">
          <el-input v-model="passwordForm.usr" disabled>
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="this.$t('password.Current_password')" prop="pwd" ref="loginPwd">
          <el-input
            v-model.trim="passwordForm.pwd"
            clearable
            type="text"
            :placeholder="$t('password.PLCurrent_password')"
            class="password"
          >
            <!-- <img slot="prefix" src="@/assets/img/mima.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="this.$t('password.New_password')" prop="newpwd" ref="enterPwd">
          <el-input
            v-model.trim="passwordForm.newpwd"
            clearable
            type="text"
            :placeholder="$t('password.PLNew_password')"
            class="password"
          >
            <!-- <img slot="prefix" src="@/assets/img/mima.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item
          :label="this.$t('password.Config_newpassword')"
          prop="confPwd"
          ref="configPwd"
        >
          <el-input
            v-model.trim="passwordForm.confPwd"
            clearable
            type="text"
            class="password"
            :placeholder="$t('password.PLConfig_newpassword')"
            @keyup.enter.native="changePassword"
          >
            <!-- <img slot="prefix" src="@/assets/img/mima.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item label=" ">
          <div class="buttonSave">
            <el-button class="button button-solid" @click="changePassword">{{$t('password.Save')}}</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 绑定手机 -->
    <el-tab-pane
      v-if="this.$lang.currentLang =='zh_CN'"
      :label="this.$t('basic.Bind_phone')"
      name="binDingPhone"
      class="section"
    >
      <el-form
        v-show="bindMobile"
        style="margin-top:150px"
        :model="sendCodeFormMobile"
        :rules="codeFormRulesMobile"
        ref="sendCodeFormMobile"
        class="chuangjian grid"
      >
        <el-form-item :label="this.$t('basic.Mobile')" prop="mobile">
          <el-input v-model="sendCodeFormMobile.mobile" :placeholder="this.$t('basic.Ple_phone')"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('basic.code')" prop="smsCode">
          <el-input
            v-model="sendCodeFormMobile.smsCode"
            style="width:150px"
            :placeholder="this.$t('basic.Ple_code')"
          ></el-input>
          <el-button
            class="button button-solid"
            v-if="show"
            @click="getCodeMobile"
            style="height: 32px;
            line-height: 32px;
            padding: 0 16px;
            font-size: 14px;
            float: right;"
          >{{$t('basic.Obtain_code')}}</el-button>
          <el-button
            class="button button-solid"
            style="height: 32px;
            line-height: 32px;
            padding: 0 16px;
            font-size: 14px;
            float: right;"
            v-if="!show"
          >{{count}} s</el-button>
        </el-form-item>
        <el-form-item label=" ">
          <div class="buttonSave">
            <el-button
              class="button button-solid"
              @click="sendCodeMobile"
            >{{$t('basic.Bind_phone')}}</el-button>
          </div>
        </el-form-item>
      </el-form>
      <el-form v-show="!bindMobile" :model="bindMobileForm" class="chuangjian grid">
        <el-form-item prop="photo" label=" ">
          <div style="text-align: center;">
            <div class="uploadbox">
              <img slot="prefix" src="@/assets/img/qrlogin.png" />
            </div>
            <p class="upload-prompt">{{$t('basic.After_bindingPh')}}</p>
          </div>
          <img slot="prefix" src="@/assets/img/qrlogin.png" />
        </el-form-item>
        <el-form-item prop="mobile" :label="this.$t('basic.Mobile')">
          <el-input v-model="bindMobileForm.mobile" disabled></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <div class="buttonSave">
            <el-button
              class="button button-solid"
              @click="unbindingMobile"
            >{{$t('basic.Untie_phone')}}</el-button>
          </div>
        </el-form-item>
        <el-form-item label=" ">
          <div class="buttonSave">
            <el-button class="button button-solid" @click="changMobile">{{$t('basic.Change_phone')}}</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 绑定邮箱 -->
    <el-tab-pane v-else :label="this.$t('basic.Bind_email')" name="binDingEmail" class="section">
      <el-form
        v-show="bindEmail"
        style="margin-top:150px"
        :model="sendCodeFormEmail"
        :rules="codeFormRulesEmail"
        ref="sendCodeFormEmail"
        class="chuangjian grid"
      >
        <el-form-item :label="this.$t('basic.Email')" prop="email">
          <el-input v-model="sendCodeFormEmail.email" :placeholder="this.$t('basic.Ple_email')"></el-input>
        </el-form-item>
        <el-form-item :label="this.$t('basic.code')" prop="smsCode">
          <el-input
            v-model="sendCodeFormEmail.smsCode"
            style="width:150px"
            :placeholder="this.$t('basic.Ple_code')"
          ></el-input>
          <el-button
            class="button button-solid"
            v-if="show"
            @click="getCodeEmail"
            style="height: 32px;
            line-height: 32px;
            padding: 0 16px;
            font-size: 14px;
            float: right;"
          >{{$t('basic.Obtain_code')}}</el-button>
          <el-button
            class="button button-solid"
            style="height: 32px;
            line-height: 32px;
            padding: 0 16px;
            font-size: 14px;
            float: right;"
            @click="getCodeEmail"
            v-if="!show"
          >{{$t('basic.re_enter')}}</el-button>
        </el-form-item>
        <el-form-item label=" ">
          <div class="buttonSave">
            <el-button class="button button-solid" @click="sendCodeEmail">{{$t('basic.Bind_email')}}</el-button>
          </div>
        </el-form-item>
      </el-form>
      <el-form v-show="!bindEmail" :model="bindEmailForm" class="chuangjian grid">
        <el-form-item prop="photo" label=" ">
          <div style="text-align: center;">
            <div class="uploadbox">
              <img slot="prefix" src="@/assets/img/qrlogin.png" />
            </div>
            <p class="upload-prompt">{{$t('basic.After_bindingEm')}}</p>
          </div>
          <img slot="prefix" src="@/assets/img/qrlogin.png" />
        </el-form-item>
        <el-form-item prop="email" :label="this.$t('basic.Email')">
          <el-input v-model="bindEmailForm.email" disabled></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <div class="buttonSave">
            <el-button
              class="button button-solid"
              @click="unbindingEmail"
            >{{$t('basic.Unbind_email')}}</el-button>
          </div>
        </el-form-item>
        <el-form-item label=" ">
          <div class="buttonSave">
            <el-button class="button button-solid" @click="changEmail">{{$t('basic.Change_email')}}</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 手机解除绑定 -->
    <basic-dialog
      :visible.sync="showMobileDialog"
      :width="'450px'"
      v-if="showMobileDialog"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="tital">
          <i class="iconfont icon-gantanhao"></i>
          <span class="contentdelete">{{$t('basic.unbind_Ph')}}</span>
        </div>
        <div class="disabledescr">{{$t('basic.unbinding_Ph')}}</div>
        <div class="deletfotter">
          <button class="button-solid" @click="confirmUnbindingMobile">{{$t('account.confirm')}}</button>
          <!-- <button class="button-hollow" @click="showMobileDialog = false">{{$t('account.cancel')}}</button> -->
        </div>
      </div>
    </basic-dialog>
    <!-- 邮箱解除绑定 -->
    <basic-dialog :visible.sync="showEmailDialog" :width="'450px'" v-if="showEmailDialog" noFooter>
      <div class="content_tishi" slot="content">
        <div class="tital">
          <i class="iconfont icon-gantanhao"></i>
          <span class="contentdelete">{{$t('basic.unbind_Em')}}</span>
        </div>
        <div class="disabledescr">{{$t('basic.unbinding_Em')}}</div>
        <div class="deletfotter">
          <button class="button-solid" @click="confirmUnbindingEmail">{{$t('account.confirm')}}</button>
          <!-- <button class="button-hollow" @click="showEmailDialog = false">{{$t('account.cancel')}}</button> -->
        </div>
      </div>
    </basic-dialog>
  </el-tabs>
</template>
<script>
import basicDialog from "@/components/dialog";
import cookie from "@/assets/js/cookie";
import upload from "@/components/upload";
export default {
  components: {
    upload,
    basicDialog
  },
  data() {
    return {
      showEmailDialog: false,
      showMobileDialog: false,
      bindMobile: true,
      bindEmail: true,
      show: true,
      count: "",
      timer: null,
      labelPosition: "right",
      activeName: this.$route.query.tab || "info",
      infoForm: {
        usr: "",
        qname: "",
        email: "",
        mobile: "",
        photo: ""
      },
      passwordForm: {
        usr: "",
        pwd: "",
        newpwd: "",
        confPwd: ""
      },
      sendCodeFormMobile: {
        mobile: "",
        smsCode: ""
      },
      sendCodeFormEmail: {
        email: "",
        smsCode: ""
      },
      bindMobileForm: {
        mobile: ""
      },
      bindEmailForm: {
        email: ""
      },
      codeFormRulesMobile: {
        mobile: [
          {
            required: true,
            message: this.$t("message.mobile_is_required")
          },
          {
            pattern: /^\d{6,32}$/,
            message: this.$t("signup.mobileformat"),
            trigger: "blur"
          }
        ],
        smsCode: [
          {
            required: true,
            message: this.$t("basic.Ple_code")
          }
        ]
      },
      codeFormRulesEmail: {
        email: [
          {
            required: true,
            message: this.$t("message.email_is_required")
          },
          {
            pattern: /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)?@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: this.$t("message.email_info"),
            trigger: "blur"
          }
        ],
        smsCode: [
          {
            required: true,
            message: this.$t("basic.Ple_code")
          }
        ]
      },
      infoFormRules: {
        email: [
          {
            required: true,
            message: this.$t("message.email_is_required"),
            trigger: "blur"
          },
          {
            pattern: /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)?@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: this.$t("message.email_info"),
            trigger: "blur"
          }
        ],
        mobile: [
          {
            required: true,
            message: this.$t("message.mobile_is_required"),
            trigger: "blur"
          },
          {
            min: 6,
            max: 32,
            message: this.$t("message.length6_32"),
            trigger: "blur"
          }
        ]
      },
      passwordFormRules: {
        // 老密码
        pwd: [
          {
            required: true,
            message: this.$t("message.pwd_is_required"),
            trigger: "blur"
          },
          {
            min: 6,
            max: 32,
            message: this.$t("message.length6_32"),
            trigger: "blur"
          }
        ],
        // 新密码
        newpwd: [
          {
            required: true,
            message: this.$t("message.pwd_is_required"),
            trigger: "blur"
          },
          {
            min: 6,
            max: 32,
            message: this.$t("message.length6_32"),
            trigger: "blur"
          },
          // 判断新旧密码是否相同
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$t("message.pwdAgain")));
              } else if (value == this.passwordForm.pwd) {
                callback(new Error(this.$t("message.pwdSame")));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        // 确认密码
        confPwd: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$t("message.pwdAgain")));
              } else if (value !== this.passwordForm.newpwd) {
                callback(new Error(this.$t("message.pwdNotsame")));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    // "$route.query.tab"(val) {
    //   this.activeName = val || "info";
    // },
    activeName(val) {
      this.activeName = val || "info";
      if (
        this.$lang.currentLang == "zh_CN" &&
        this.$refs.sendCodeFormMobile !== undefined
      ) {
        // this.$refs.sendCodeFormMobile.resetFields();
      } else if (
        this.$lang.currentLang != "zh_CN" &&
        this.$refs.sendCodeFormEmail !== undefined
      ) {
        this.$refs.sendCodeFormEmail.resetFields();
      }
      this.getData();
      this.getMobileData();
    }
  },
  mounted() {
    this.getData();
    this.getMobileData();
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    //获取数据
    getData() {
      this.$request.get("queryAccountInfo").then(res => {
        if (res.err === 0) {
          this.infoForm = res.dat;
          // this.usr = res.dat.usr;
          this.passwordForm.usr = res.dat.usr;
          if (this.$lang.currentLang != "zh_CN" && res.dat.emailAccr == true) {
            this.bindEmail = false;
            this.bindEmailForm.email = res.dat.email;
          } else {
            this.bindEmail = true;
          }
        } else {
          this.bindEmail = true;
        }
      });
    },
    getMobileData() {
      this.$request.get("queryUsrBindMobileStatus").then(res => {
        if (res.err === 0) {
          if (res.dat.status == true) {
            this.bindMobile = false;
            this.bindMobileForm.mobile = res.dat.mobile;
          } else {
            this.bindMobile = true;
          }
        } else {
          this.bindMobile = true;
        }
      });
    },
    submitForm() {
      this.$refs.infoForm.validate(valid => {
        if (valid) {
          let param = {
            usr: this.infoForm.usr,
            qname: this.infoForm.qname,
            email: this.infoForm.email ? this.infoForm.email : " ",
            mobile: this.infoForm.mobile ? this.infoForm.mobile : " ",
            photo: this.infoForm.photo
          };
          this.$request.get("editAccount", param).then(res => {
            if (res.err == 0) {
              this.$message.success(this.$t("basic.modifySuc"));
              this.passwordForm.pwd = "";
              this.passwordForm.newpwd = "";
              this.passwordForm.confPwd = "";
              // 同步全局用户状态
              this.$store.commit("saveUserInfo", { avatar: param.photo });
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
            }
          });
        }
      });
    },
    changePassword() {
      this.$refs.passwordForm.validate(valid => {
        if (!valid) return false;
        this.$request
          .changePwd(this.passwordForm.newpwd, this.passwordForm.pwd)
          .then(res => {
            if (res.err == 0) {
              if (cookie.getCookie("role") == this.$store.state.user.role) {
                this.$message.success(this.$t("password.loginAgain"));
                this.$store.commit("logout");
                this.$router.push("/entry");
              } else {
                this.getData();
                this.$message.success(this.$t("password.editPwdSuc"));
              }
            } else if (res.err == 17) {
              this.$message.error(this.$t("message.oldPass_wrong"));
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
            }
          });
      });
    },
    unbindingMobile() {
      this.showMobileDialog = true;
    },
    unbindingEmail() {
      this.showEmailDialog = true;
    },
    // 解绑手机
    confirmUnbindingMobile() {
      this.$request.get("editUsrBindMobileStatus").then(res => {
        if (res.err === 0) {
          this.getMobileData();
          this.$refs.sendCodeFormMobile.resetFields();
          this.showMobileDialog = false;
        }
      });
    },
    // 解绑邮箱
    confirmUnbindingEmail() {
      let param = {
        usr: this.passwordForm.usr,
        email: this.bindEmailForm.email,
        emailAccr: 0
      };
      this.$request.get("unbindingEmail", param).then(res => {
        if (res.err === 0) {
          this.getData();
          this.$refs.sendCodeFormEmail.resetFields();
          this.showEmailDialog = false;
        }
      });
    },
    changMobile() {
      this.bindMobile = true;
    },
    changEmail() {
      this.bindEmail = true;
    },
    getCodeMobile() {
      let check = /^\d{6,32}$/;
      if (!this.sendCodeFormMobile.mobile) {
        this.$message.error(this.$t("retrieve.mobile_first"));
      } else if (!check.test(this.sendCodeFormMobile.mobile)) {
        this.$message.error(this.$t("signup.mobileformat"));
      } else {
        let param = {
          mobile: this.sendCodeFormMobile.mobile,
          msgType: 9,
          source: 1
        };
        this.$request.get("sendSmsCodeLogin", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("basic.mobile_code"));
            const TIME_COUNT = 90;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else if (res.err == 524) {
            this.$message.error(this.$t("basic.code_frequently"));
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
      }
    },
    getCodeEmail() {
      let check = /^[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)?@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!this.sendCodeFormEmail.email) {
        this.$message.error(this.$t("message.email_is_required"));
      } else if (!check.test(this.sendCodeFormEmail.email)) {
        this.$message.error(this.$t("message.email_info"));
      } else {
        let param = {
          usr: this.passwordForm.usr,
          email: this.sendCodeFormEmail.email,
          msgType: "09",
          channel: "01",
          i18n: this.$lang.currentLang,
          webName: "DessMonitor",
          emailAccr: 1,
          source: 1
          // email: this.sendCodeFormEmail.email,
          // msgType: 9,
          // source: 1
        };
        this.$request.get("bindingEmail", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("basic.email_code"));
            this.show = false;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
      }
    },
    sendCodeMobile() {
      this.$refs.sendCodeFormMobile.validate(valid => {
        if (!valid) return false;
        let param = {
          mobile: this.sendCodeFormMobile.mobile,
          msgType: 0x09,
          smsCode: this.sendCodeFormMobile.smsCode
        };
        this.$request.get("bindUsrMobile", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("basic.suc_ph"));
            this.getMobileData();
            this.bindMobile = false;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
      });
    },
    sendCodeEmail() {
      this.$refs.sendCodeFormEmail.validate(valid => {
        if (!valid) return false;
        let param = {
          usr: this.passwordForm.usr,
          email: this.sendCodeFormEmail.email,
          smsCode: this.sendCodeFormEmail.smsCode,
          msgType: "09",
          channel: "01",
          i18n: this.$lang.currentLang,
          webName: "DessMonitor",
          emailAccr: 1,
          source: 1
        };
        this.$request.get("bindingEmailStatus", param).then(res => {
          if (res.err == 0) {
            this.$message.success(this.$t("basic.suc_em"));
            this.getData();
            this.bindEmail = false;
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
      });
    }
  }
};
</script>
<style lang="less" scoped>
.personal {
  flex: 1;
  display: flex;
  margin: 10px;
  // margin: 24px 24px 50px 24px;
  flex-direction: column;
  background-color: #fff;
  border-radius: 4px;
  /*按钮*/
  .boxheader {
    margin-bottom: 20px;
    font-size: 24px;
  }
  /*字体*/
  .label {
    margin-left: 10px;
  }
  .chuangjian {
    grid-row-gap: 30px;
    // /deep/ .el-input__prefix {
    //   width: 40px;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    // }
    // /deep/ .el-input__inner {
    //   padding-left: 40px;
    // }
  }
}
</style>
<style lang="less">
.personal {
  .el-tabs__content {
    padding-top: 20px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    .section {
      // height: auto;
      // padding-right: 15%;
      // padding: 40px 40px 30px;
      border: none;
      box-shadow: none;
      .buttonSave {
        display: flex;
        justify-content: center;
        .button {
          height: 32px;
          line-height: 32px;
          padding: 0 16px;
          font-size: 14px;
          width: 100%;
        }
      }
    }
    .upload-container {
      margin-bottom: 5px;
    }
  }
  .el-form {
    // width: 540px;
    .el-input {
      width: 300px;
      // height: 40px;
      .el-input__inner {
        border-radius: 7px;
        border-color: rgba(228, 228, 228, 1);
      }
    }
    .el-form-item {
      // padding-right: 25%;
      margin-bottom: 25px;
    }
  }
}
</style>